import { Route, Routes } from 'react-router-dom';
import {
  ProcessBuilderList,
  ProcessBuilderPage,
} from '@/capabilities/automation-library/public/routes/lazyPages';
import {
  RunwayHandoffsPage,
  RunwayHistoryPage,
  RunwayInFlightPage,
  RunwayInstanceDetailPage,
  RunwayIntranetTemplatePage,
  RunwayStartNewPage,
} from '@/capabilities/automation-runbooks/routes';
import { destinationCapabilityRouteElements } from '@/app/navigation/routes/capabilities/destinationCapabilityRegistry';

export function RunwayRoutes() {
  return (
    <Routes>
      <Route index element={<RunwayInFlightPage />} />
      <Route path="new" element={<RunwayStartNewPage />} />
      <Route path="templates" element={<ProcessBuilderList />} />
      <Route path="templates/:id/preview" element={<ProcessBuilderPage preview />} />
      <Route path="templates/:id/edit" element={<ProcessBuilderPage />} />
      <Route path="handoffs" element={<RunwayHandoffsPage />} />
      <Route path="history" element={<RunwayHistoryPage />} />
      <Route path="instances/:id" element={<RunwayInstanceDetailPage />} />
      <Route path="sharepoint/intranet" element={<RunwayIntranetTemplatePage />} />
      {destinationCapabilityRouteElements('runway')}
    </Routes>
  );
}
